import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import styles from './Spinner.styles';

const Spinner = ({ fadeIn }) => {
  return (
    <div
      css={css`
        ${fadeIn && styles.fadein}
      `}
    >
      <div css={styles.root} className="w3 h3 bg-transparent b--solid bw2" />
    </div>
  );
};

Spinner.defaultProps = {
  fadeIn: false,
};

Spinner.propTypes = {
  fadeIn: PropTypes.bool,
};

export default Spinner;
